import { render, staticRenderFns } from "./purchaseReturnAccountAction.vue?vue&type=template&id=43b65b2a&scoped=true"
import script from "./purchaseReturnAccountAction.vue?vue&type=script&lang=js"
export * from "./purchaseReturnAccountAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnAccountAction.vue?vue&type=style&index=0&id=43b65b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b65b2a",
  null
  
)

export default component.exports